import { fetchAuthSession } from "aws-amplify/auth";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSnackbarContext } from "../../utils/snackbar/SnackbarContext";
import { appConstants } from "../../utils/appConstants";
import { useDropzone } from 'react-dropzone';
import { useParams } from "react-router-dom";

const CouponEdit = () => {
  const [name, setName] = useState("");
  const [teika, setTeika] = useState("");
  const [baika, setBaika] = useState("");
  const [code, setCode] = useState("");
  const [usagelimit, setUsagelimit] = useState("");
  const [special, setSpecial] = useState("");
  const [starttime, setStarttime] = useState("");
  const [endtime, setEndtime] = useState("");
  const [status, setStatus] = useState<number>(1);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const { showSnackbar } = useSnackbarContext();


  // URLからIdパラメータを取得
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    (async () => {
      try {
        const { idToken } = (await fetchAuthSession()).tokens ?? {};
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/coupon/${id}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            }
          }
        );
        // console.log('Response:', response.data);
        const coupon = response.data;
        setName(coupon.name);
        setTeika(coupon.teika);
        setBaika(coupon.baika);
        setCode(coupon.code);
        setUsagelimit(coupon.usagelimit);
        setSpecial(coupon.special);
        setStarttime(coupon.starttime);
        setEndtime(coupon.endtime);
        setStatus(coupon.status);

        const imageFileName = `coupon-1-1-${id}`;
        // ユニークなタイムスタンプを付与してキャッシュ対策 
        const timestamp = new Date().getTime();
        const imageRes = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/image/${imageFileName}?t=${timestamp}`,
          {
            headers: {
              'Content-Type': 'application/json'
            },
            responseType: 'blob',
          }
        );
        const imageUrl = URL.createObjectURL(imageRes.data);
        setPreview(imageUrl);
      } catch (error) {
        console.error('Error fetching coupon:', error);
      }
    })();
  }, []);

  const onDrop = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const coupon = {
      name,
      teika,
      baika,
      code,
      usagelimit,
      special,
      starttime,
      endtime,
      status
    };

    try {
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/coupon/${id}`,
        coupon,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        }
      );
      // console.log('Response:', response.data);

      if (response.data) {
        if (selectedFile) {
          // クーポンIDを元に画像名を生成してアップロード
          const id = response.data.id;
          const fileName = `coupon-1-1-${id}`;
          const extension = selectedFile.name.substring(selectedFile.name.lastIndexOf('.') + 1);
          const formData = new FormData();
          formData.append('image', selectedFile, fileName + '.' + extension);

          try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/upload-image`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${idToken}`
              },
            });
            console.log('ファイルのアップロードが完了しました', response.data);
          } catch (error) {
            console.error('ファイルのアップロードに失敗しました', error);
          }
        }
        showSnackbar("success", appConstants.SUCCESS_UPDATE);
      }
    } catch (error) {
      console.error('Error posting coupon:', error);
    }
  }


  return (
    <>
      <h2>1. 基本情報</h2>
      <form onSubmit={handleSubmit}>
        <div className="tableEdit">
          <div
            {...getRootProps()}
            style={{
              border: '2px dashed #cccccc',
              padding: '20px',
              textAlign: 'center',
              cursor: 'pointer',
            }}
          >
            <input {...getInputProps()} />
            {preview ? (
              <img src={preview} alt="Preview" style={{ maxWidth: '300px'}} />
            ) : (
              <p>ここをクリックするか画像をドラッグしてください</p>
            )}
          </div>
          <table>
            <tbody>
              <tr>
                <th>クーポン名</th>
                <td>
                  <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>通常定価</th>
                <td>
                  <input type="text" name="teika" value={teika} onChange={(e) => setTeika(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>クーポン価格</th>
                <td>
                  <input type="text" name="baika" value={baika} onChange={(e) => setBaika(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>コード</th>
                <td>
                  <input type="text" name="code" value={code} onChange={(e) => setCode(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>使用回数制限</th>
                <td>
                  <input type="text" name="usagelimit" value={usagelimit} onChange={(e) => setUsagelimit(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>利用制限</th>
                <td>
                  <input type="text" name="special" value={special} onChange={(e) => setSpecial(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>クーポン公開日</th>
                <td>
                  <input type="text" name="starttime" value={starttime} onChange={(e) => setStarttime(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>クーポン終了日</th>
                <td>
                  <input type="text" name="endtime" value={endtime} onChange={(e) => setEndtime(e.target.value)} required />
                </td>
              </tr>
              <tr>
                <th>ステータス</th>
                <td>
                  <input type="radio" name="status" value={0} id="status0" checked={status === 0} onChange={(e) => setStatus(parseInt(e.target.value))}/> 
                  <label htmlFor="status0" style={{ marginRight: '10px' }}>非公開</label>
                  <input type="radio" name="status" value={1} id="status1" checked={status === 1} onChange={(e) => setStatus(parseInt(e.target.value))}/>
                  <label htmlFor="status1">公開</label>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <div className="submit">
                    <input type="submit" value="更新" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </>
  );
}
export default CouponEdit;